// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { beamTestnet as _beamTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the beamTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 13337
 * Chain Name: Beam Testnet
 * Default Block Explorer: https://subnets-test.avax.network/beam
 * Default RPC URL: https://build.onbeam.com/rpc/testnet
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { beamTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: beamTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const beamTestnet = createCommon({
	..._beamTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
